module.exports = __webpack_public_path__ + "img/content_right4.35c250cf.png";